module.exports = __webpack_public_path__ + "static/DonaAlt-Bold-cde73e98aeba283d21abe6bfdedc8c98.eot";